import React, { useEffect } from 'react';
import { message } from 'antd';

let messageApi = null;

const Notify = () => {
    const [api, contextHolder] = message.useMessage();

    useEffect(() => {
        messageApi = api;
    }, [api]);

    return <>{contextHolder}</>
};

export const notify = {
    success: ({ message }) => {
        messageApi?.success(message);
    },
    error: ({ message }) => {
        messageApi?.error(message);
    },
    warning: ({ message }) => {
        messageApi?.warning(message);
    },
    info: ({ message }) => {
        messageApi?.info(message);
    },
};

export default Notify;
